import Swup from 'swup';
import Site from './site.js';
import Cart from './shop/cart.js';
import CartComponent from './shop/cartComponent.js';
import CartItem from './shop/cartItem';
import SwupScriptsPlugin from '@swup/scripts-plugin';

// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import Clipboard from "@ryangjchandler/alpine-clipboard"
import intersect from '@alpinejs/intersect'


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [new SwupScriptsPlugin({
    optin: true
  })]
};






const swup = new Swup(options); 

// Events
swup.hooks.on("page:view", (visit) => {
  init();
});

Alpine.plugin(Clipboard);
Alpine.plugin(intersect);

// Start Apline after swup so it works correctly
window.Alpine = Alpine;

Alpine.data('site', Site);
Alpine.data('cart', CartComponent);
Alpine.data('cartitem', CartItem)
Alpine.store('cart', Cart);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  initYouTubeVideos();

  // setTimeout(function() {
  //   if (document.querySelector('.instagram-media')) {
  //     l('try instagram embed');
  //     // location.reload();
  //     // window.instgrm.Embeds.process();
  //   }
  // }, 1000);
}



// Light YouTube Embeds by @labnol
// Credit: https://www.labnol.org/

function labnolIframe(div) {
  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', 'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
  div.parentNode.replaceChild(iframe, div);
}

function initYouTubeVideos() {
  console.log('initYouTubeVideos');
  var playerElements = document.querySelectorAll('.youtube-player');
  for (var n = 0; n < playerElements.length; n++) {
    var videoId = playerElements[n].dataset.id;
    var div = document.createElement('div');
    div.setAttribute('data-id', videoId);
    var thumbNode = document.createElement('img');
    thumbNode.src = '//i.ytimg.com/vi/ID/hqdefault.jpg'.replace('ID', videoId);
    div.appendChild(thumbNode);
    var playButton = document.createElement('div');
    playButton.setAttribute('class', 'play');
    div.appendChild(playButton);
    div.onclick = function () {
      labnolIframe(this);
    };
    playerElements[n].appendChild(div);
  }
}
